<template>
    <nav class="tabbed-nav" :id="navId" :aria-label="label" role="navigation">
        <div role="presentation" class="nav-pre"></div>
        <ul role="menubar">
                <li :class="{active: activeTab===idx}" v-for="(key, idx) in tabs" :key="'nav-'+idx"><button :data-tabindex="idx" @click="updateTab">{{key}}</button></li>
        </ul>
        <div role="presentation" class="nav-post"></div>
    </nav>
</template>

<script>
export default {
  name: "Tabs",
  props: {
      navId: {
          type: String,
          required: true
      },
      label: {
          type: String,
          required: true
      },
      tabs: {
          type: Array,
          required: true
      },
      activeTab: Number,
      change: Function
  },
  methods:{
      updateTab(e){
          if(this.change!==undefined){
              this.change(parseInt(e.target.dataset['tabindex']));
          }
      }
  }
}

</script>

<style>
nav.tabbed-nav ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

nav.tabbed-nav ul li {
  display: inline-block;
}

nav.tabbed-nav {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

div.nav-pre,
div.nav-post {
  border-bottom: 1px solid #4a4f62;
}

nav.tabbed-nav div.nav-pre {
  /* -webkit-flex-grow: 1;
  flex-grow: 1; */
  width: 4em;
}

nav.tabbed-nav div.nav-post {
  -webkit-flex-grow: 6;
  flex-grow: 6;
}

nav.tabbed-nav button {
  color: #fff;
  background: #4a4f62;
  font-size: 1em;
  font-weight: normal;
  padding: 0.5em;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  cursor: pointer;
  border: 1px solid #4a4f62;
  border-bottom: none;
  transition: all .3s ease-in-out;
}

nav.tabbed-nav ul li:not(:last-of-type) {
  padding-right: 0.5em;
}

nav.tabbed-nav ul li:not(.active) {
  border-bottom: 1px solid #4a4f62;
}

nav.tabbed-nav ul li.active {
  margin-left: -1px;
  margin-right: -1px;
  padding-right: 0;
}

nav.tabbed-nav ul li.active + li{
  padding-left: 0.5em;
}

nav.tabbed-nav ul li {
    transition: all .3s ease-in-out;
}

nav.tabbed-nav ul li button:hover{
  color: #414141;
  background: #fff;
}

nav.tabbed-nav ul li.active button {
  color: #414141;
  background: #fff;
  box-shadow: 2px -2px 4px 0px rgba(0, 0, 0, .12);
}

nav.tabbed-nav ul li button{
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Tabs.vue